const setPersonalDetailField = (payload) => ({
  type: "SET_MP_NIN_PERSONAL_DETAIL_FIELD",
  payload,
});

const setResidenceField = (payload) => ({
  type: "SET_MP_NIN_RESIDENCE_FIELD",
  payload,
});

const setEmployerField = (payload) => ({
  type: "SET_MP_NIN_EMPLOYER_FIELD",
  payload,
});

const setNextOfKinField = (payload) => ({
  type: "SET_MP_NIN_NEXTOFKIN_FIELD",
  payload,
});

const setPictureField = (payload) => ({
  type: "SET_MP_NIN_PICTURE_FIELD",
  payload,
});

const setSignatureField = (payload) => ({
  type: "SET_MP_NIN_SIGNATURE_FIELD",
  payload,
});

const setConsentFormField = (payload) => ({
  type: "SET_MP_NIN_CONSENT_FORM_FIELD",
  payload,
});

const setBankDetailsField = (payload) => ({
  type: "SET_MP_NIN_BANK_DETAILS_FIELD",
  payload,
});

const getUser = (payload) => ({
  type: "GET_MP_NIN_USER",
  payload,
});

const setIsFormHidden = (payload) => ({
  type: "SET_MP_NIN_IS_FORM_HIDDEN",
  payload,
});

const setBaseURL = (payload) => ({
  type: "SET_MP_NIN_BASE_URL",
  payload,
});

const setMPNINVerificationToken = (payload) => ({
  type: "SET_MP_NIN_VERIFICATION_TOKEN",
  payload,
});

const resetRSAForm = () => ({ type: "RESET_MP_NIN_FORM" });

const setToken = (payload) => ({ type: "SET_MP_NIN_TOKEN", payload });

const setAllStates = (payload) => ({ type: "SET_ALL_MP_NIN_STATES", payload });

const setAllLGA = (payload) => ({ type: "SET_ALL_MP_NIN_LGA", payload });

const setAllPermStates = (payload) => ({ type: "SET_ALL_MP_NIN_PERM_STATES", payload });

const setAllPermLGA = (payload) => ({ type: "SET_ALL_MP_NIN_PERM_LGA", payload });

const setAllNOKStates = (payload) => ({ type: "SET_ALL_MP_NIN_NOK_STATES", payload });

const setAllNOKLGA = (payload) => ({ type: "SET_ALL_MP_NIN_NOK_LGA", payload });

const setIsNINVerified = (payload) => ({ type: "SET_MP_NIN_VERIFIED", payload });

export default {
  setPersonalDetailField,
  setResidenceField,
  setEmployerField,
  setNextOfKinField,
  setPictureField,
  setSignatureField,
  setConsentFormField,
  setBankDetailsField,
  getUser,
  resetRSAForm,
  setBaseURL,
  setIsFormHidden,
  setMPNINVerificationToken,
  setToken,
  setAllStates,
  setAllLGA,
  setAllNOKStates,
  setAllNOKLGA,
  setIsNINVerified,
  setAllPermStates,
  setAllPermLGA
};
